// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media not (min-width:658px){body[data-is-support-mobile-view=true] .DPNzxTk64kmmoQI_Diwv{padding:0}}.DPNzxTk64kmmoQI_Diwv:before{left:0;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `DPNzxTk64kmmoQI_Diwv`
};
export default ___CSS_LOADER_EXPORT___;
